import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  createFundCommitment,
  updateFundCommitment,
  deleteFundCommitment,
} from '../../api/finance/fundCommitments';

export const useFundCommitmentMutations = (queryKey = ['fundCommitments']) => {
  const queryClient = useQueryClient();

  const invalidate = async () => {
    await queryClient.invalidateQueries({ queryKey, exact: false });
  };

  return {
    createMutation: useMutation({
      mutationFn: createFundCommitment,
      onSuccess: invalidate,
    }),
    updateMutation: useMutation({
      mutationFn: updateFundCommitment,
      onSuccess: invalidate,
    }),
    deleteMutation: useMutation({
      mutationFn: deleteFundCommitment,
      onSuccess: invalidate,
    }),
  };
};

export default useFundCommitmentMutations;
